const ImagePreloader = (props) => {
  return (
    <>
      {props.Images.map((Item) => (
        <img alt="preloaded-image" hidden src={Item} />
      ))}
    </>
  );
};

export default ImagePreloader;
